import * as React from 'react';
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12.908} height={22.646} {...props}>
    <path
      fill="#fff"
      d="M11.323 22.646 0 11.323 11.323 0l1.585 1.614-9.71 9.71 9.71 9.709Z"
      data-name="arrow left"
    />
  </svg>
);
export default SvgComponent;
